import ViewMessage from "./view-message";

export default class ViewMessages {
  #parsed;
  #viewMessages;
  #$wrap;

  get empty() {
    return this.#parsed == null;
  }

  get parsed() {
    return this.#parsed;
  }

  constructor() {
    this.#viewMessages = new Map();
  }

  parse(messages) {
    if (messages) {
      this.#parsed = JSON.parse(messages);

      Object.values(this.#parsed).forEach((message) => {
        const vm = new ViewMessage(message);
        this.#viewMessages.set(vm.type, vm);
      });
    }
  }

  display($container) {
    if (!$container) {
      $container = $("body");
    }
    this.#$wrap = $container.find(".view-msg-wrap")

    this.#viewMessages.forEach((viewMessage) => {
      viewMessage.display($container);
    });
  }

  scrollTo() {
    window.scroller.scrollToElemTop(this.#$wrap);
  }

  clear($container) {
    const $wrap = $container.find(".view-msg-wrap");
    $wrap.empty();
  }

  hasAlert() {
    return this.#viewMessages.has("alert");
  }
  hasWarning() {
    return this.#viewMessages.has("warning");
  }
  hasInfo() {
    return this.#viewMessages.has("info");
  }

  getAlert() {
    return this.#viewMessages.get("alert");
  }
  getWarning() {
    return this.#viewMessages.get("warning");
  }
  getInfo() {
    return this.#viewMessages.get("info");
  }
}
